export default __webpack_public_path__ + "static/media/nsoesie.9f9a125c.png";